import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

import { BuildEnvironment } from "../../../environments/environment";
import { IStatus } from "../models/lookup.model";

@Injectable({
  providedIn: "root",
})
export class LookupsService {
  //"https://serverjanv1.azurewebsites.net/public/controllers/api";

  constructor(private http: HttpClient) {}

  //var tableArray:string[] = ['status','priority','country','province'];
  /*
   *---Note tablename should be one of the array elements above---//
   */
  getLookupByTableAlias(tablename: string): Observable<IStatus[]> {
    const rootURL = BuildEnvironment.GetEnvironmentUrl();

    return this.http.get<IStatus[]>(rootURL + "/lookups/tables/" + tablename);
  }
}
